import { render, staticRenderFns } from "./ManagerNavbar.vue?vue&type=template&id=7f08ce5f&scoped=true"
import script from "./ManagerNavbar.vue?vue&type=script&lang=js"
export * from "./ManagerNavbar.vue?vue&type=script&lang=js"
import style0 from "./ManagerNavbar.vue?vue&type=style&index=0&id=7f08ce5f&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08ce5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f08ce5f')) {
      api.createRecord('7f08ce5f', component.options)
    } else {
      api.reload('7f08ce5f', component.options)
    }
    module.hot.accept("./ManagerNavbar.vue?vue&type=template&id=7f08ce5f&scoped=true", function () {
      api.rerender('7f08ce5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/ManagerNavbar.vue"
export default component.exports